import { render, staticRenderFns } from "./PasswordResetRegistered.vue?vue&type=template&id=72188b12&scoped=true&"
import script from "./PasswordResetRegistered.vue?vue&type=script&lang=js&"
export * from "./PasswordResetRegistered.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetRegistered.vue?vue&type=style&index=0&id=72188b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72188b12",
  null
  
)

export default component.exports